module.exports = __webpack_public_path__ + "img/bg-desktop.1ac8c101.png";